module.exports = __webpack_public_path__ + "img/roll_l_f.02dc1ce9.png";